//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
export default {
  props: {
  },
  computed: mapState([
    'gotoRegister',
  ]),
  data() {
    return {
    };
  },
  methods: {
    register() {
      const bjtUrlList = JSON.parse(localStorage.getItem("bjtUrlList"));
      window.location.href = bjtUrlList.bjtRegisterUrl;
    },
    close() {
      this.$store.commit("setGotoRegister", { show: false, allowClose: false });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/gotoRegister.vue